/* eslint-disable no-useless-constructor */
import feathersClient, { makeServicePlugin, BaseModel } from '../../api'

class DamageReports extends BaseModel {
  constructor (data, options) {
    super(data, options)
  }

  // Required for FeathersVuex plugin to work after production transpile.
  static modelName = 'DamageReports'
  // Define default properties here
  static instanceDefaults () {
    return {
      SCHADEN: {},
      INFO: {},
      ZAHLUNG: {
        GRUND: []
      },
      FIELDS: {
        requestId: []
      }
    }
  }
}
const servicePath = 'damage-reports'
const servicePlugin = makeServicePlugin({
  Model: DamageReports,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
